import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import HeaderIconColorContext from "../../contexts/header-icon-color-context";
import { MoreIcon } from "./more-link";
import logo from "../../assets/images/apocampusLogo.png";
import backIcon from "../../assets/images/back_left_icon.png";
import heart from "../../assets/images/heart_icon.png";
import filledHeart from "../../assets/images/filled_heart.png";
import ReactDOM from 'react-dom';
import signOutIcon from "../../assets/images/signOut.png";
import questionMarkIcon from "../../assets/images/questionMark.png";
import { LIKE_NEWS_ENTRY } from "queries/mutations";
import { GET_LIKED_ENTRIES, GET_USER_POINTS_QUERY } from "queries/queries";
import logoRound from '../../assets/images/logo_round.png'
import giftIcon from '../../assets/images/gift-box.png';
import bookmarkIcon from '../../assets/images/bookmark.png'
import moreIcon from '../../assets/images/moreIcon.png'

const Header = (({ title, handleLogOut, showHeart, entryId, setShowEntryList, showEntryList }) => {

  // const { loading, error, data, refetch } = useQuery(GET_LIKED_ENTRIES, {
  //   fetchPolicy: "no-cache",
  // });
  
  const { loading, error, data } = useQuery(GET_USER_POINTS_QUERY, {
    fetchPolicy: "no-cache"
  });

  const points = data?.statistics?.availablePoints;

  const likedEntries = data?.getLikedEntries;

  let location = useLocation();
  const history = useHistory();
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [likedEntry, setLikedEntry] = useState(false);

  const toggleMore = () => {
    setIsMoreOpen(!isMoreOpen); 
  };

  const defaultHeaderIconColor =
    location.pathname === "/achievements" ? "color" : "white";
  const showProfileLink = location.pathname === "/";
  const showLogo = location.pathname === '/'

  const defaultTitle = (() => {
    if (location.pathname.startsWith('/news/')) {
      return 'Dein News-Feed';
    }
    if (location.pathname.startsWith('/appointment-details/')) {
      return 'Schulung';
    }
    if (location.pathname.startsWith('/registration/')) {
      return 'Registrieren';
    }
    if (location.pathname.startsWith('/coupon/')) {
      return 'Coupon';
    }
    if (location.pathname.startsWith('/my-coupon/')) {
      return 'Coupon';
    }
    if (location.pathname.startsWith('/category_courses/')) {
      return 'Dein Wissensbereich';
    }
    switch (location.pathname) {
      case '/news':
        return 'Dein News-Feed';
      case '/favorites':
        return 'Deine Favoriten';
      case '/about':
        return 'About Us';
      case '/courses':
        return 'Dein Wissensbereich';
      case '/courses-result':
        return 'Suchergebnisse';
      case '/thank-you':
        return 'Vielen Dank';
      case '/trainer':
        return 'Meine Trainer:innen';
      case '/trainer-message':
        return 'Nachricht schreiben';
      case '/appointments-list':
        return 'Schulungen';
      case '/appointment-book':
        return 'Termin vereinbaren';
      case '/appointments-suggestion':
        return 'Schulungen vormerken';
      case '/certificates':
        return 'Meine Zertifikate';
      case '/profile-points':
        return 'Meine Punkte';
      case '/coupons-list':
        return 'Meine Coupons';
      case '/edit_profile':
        return 'Bearbeiten';
      case '/profile-edit':
        return 'Bearbeiten';
      case '/profile':
        return 'Mein Profil';
      case '/data-protection':
        return 'Datenschutzerklärung';
      case '/agb':
        return 'AGB';
      case '/rules':
        return 'Teilnahmebedingungen';
      case '/faq':
        return 'FAQ';
      case '/impressum':
        return 'Impressum';
      case '/surveys-list':
        return 'Umfrage';
    }
  })();

  const handleBack = () => {
    if (location.pathname === '/courses') {
      history.push('/') 
      return
    }else if (location.pathname.startsWith('/course_details/')) {
      history.push('/courses') 
      return
    } else if (location.pathname.startsWith('/course/')) {
      history.push('/courses') 
      return
    } else if  (location.pathname.startsWith('/courses/')) {
      history.push('/courses') 
      return
    } else if (location.pathname === '/thank-you') {
      history.push('/') 
      return
    } else if (location.pathname === '/surveys') {
      history.push('/') 
      return
    } else if (location.pathname.startsWith('/news/') && !showEntryList) {
      setShowEntryList(true)
      return    
    } else if (location.pathname.startsWith('/news/') && showEntryList) {
      history.goBack() 
      return
    } {
      history.goBack() 
      return
    }
  }

  // const [likeNewsEntry] = useMutation(LIKE_NEWS_ENTRY, {
  //   onCompleted: (response) => {
  //     const isSuccess = response?.likeNewsEntry?.newsEntry
  //     if (isSuccess) {
  //       refetch();
  //     }
  //   },
  //   onError: (data) => {
  //     console.log("error", data);
  //   },
  // });

  // const handleHeartClick = () => {
  //   if (entryId) {
  //     const numericEntryId = Number(entryId); 
  //     if (!isNaN(numericEntryId)) {
  //       likeNewsEntry({
  //         variables: {
  //           entryId: numericEntryId,
  //         },
  //       }).catch((err) => {
  //         console.error("Error liking the entry:", err);
  //       });
  //     } else {
  //       console.error("Invalid entryId, unable to cast to number:", entryId);
  //     }
  //   } else {
  //     console.warn("No entryId provided, skipping mutation.");
  //   }
  // };

  useEffect(() => {
    const isLiked = likedEntries?.some((entry) => entry.id === entryId);
    setLikedEntry(isLiked || false);
  }, [likedEntries, entryId]);
  
  const showBackButton = location.pathname !== '/'

  return (
    <div className="header">
      <div className='header-logo'>
        <img src={logoRound} alt="Logo" className='header-logo-image'/>
      </div>
        <div 
          className='header-points'             
          onClick={e => {
            e.preventDefault();
              history.push('/profile-points');
            }}>{`${points} Punkte`}
        </div>
        <div className='header-icon'>
        <img src={giftIcon} alt='Icon' onClick={() => history.push('/coupons-list')}/>
        </div>
        <div className='header-icon'>
        <img src={bookmarkIcon} alt='Icon' onClick={() => history.push('/certificates')}/>
      </div>
        <div className='header-icon'>
        <img src={moreIcon} alt='Icon' onClick={toggleMore}/>
        </div>
      {/* More window */}
      {isMoreOpen && ReactDOM.createPortal(
        <div className="more-window">
        <div className="more-window-content">
          <button onClick={handleLogOut}>
            <img src={signOutIcon} alt="LogOut" />
            Ausloggen
          </button>
          <div className="support-section">
            <div className="support-section-title">
              <img src={questionMarkIcon} alt="Question Mark" />
              <span>Support</span>
            </div>
            <p>
              Bei Fragen sind wir gerne für dich da. Schreibe uns eine E-Mail
              an support@aposphaere.de
            </p>
          </div>
          <div className="more-footer">
            <div 
              onClick={() => history.push('/data-protection')}
            >Datenschutz</div>
            <div
              onClick={() => history.push('/impressum')}
            >Impressum</div>
            <div 
              onClick={() => history.push('/agb')}
            >AGB</div>
          </div>
        </div>
        </div>,
        document.body
      )}

    </div>
  );
  });

export default Header;
